import axios from 'axios';
import { makeAutoObservable } from 'mobx';

import { getPortalRuntimeConfig } from '../../services/runtimeConfig';

export interface IMedia {
  resourceType: string;
  thumbnailUrl: string;
  url: string;
  uuid: string;
  videoCoverImage: string;
}

export interface uploadFunctionProps {
  tags: string[];
  publicId: string;
  blob: Blob;
}

export interface IMediaStore {
  upload({ tags, publicId, blob }: uploadFunctionProps): Promise<
    | {
        uuid: string;
        media: {
          url: string;
          resourceType: string;
        };
      }
    | undefined
  >;
}

const cloudinaryClinicFolder = 'clinic_uploads';

export default class MediaStore implements IMediaStore {
  constructor() {
    makeAutoObservable(this);
  }

  async upload({ tags, publicId, blob }: uploadFunctionProps) {
    const signatureResult = await axios.post('/api/media/sign', {
      publicId,
      tags,
      folder: cloudinaryClinicFolder,
    });

    const { apiKey, signature, timestamp } = signatureResult.data;

    const formData = new FormData();

    formData.append('file', blob);
    formData.append('api_key', apiKey);
    formData.append('public_id', publicId);
    formData.append('timestamp', timestamp);
    formData.append('signature', signature);
    formData.append('tags', tags.join(','));
    formData.append('folder', cloudinaryClinicFolder);

    const cloudinaryResult = await axios.post(
      `https://api.cloudinary.com/v1_1/${getPortalRuntimeConfig().cloudinary.cloudName}/auto/upload`,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: false,
      },
    );

    // Send the secure_url as default url
    const mediaResult = await axios.post('/api/media', {
      ...cloudinaryResult.data,
      url: cloudinaryResult.data.secure_url,
    });

    return {
      uuid: mediaResult?.data?.uuid,
      media: {
        url: cloudinaryResult.data.secure_url,
        thumbnailUrl: cloudinaryResult.data.secure_url,
        resourceType: cloudinaryResult.data.resource_type,
      },
    };
  }
}
